var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.273 4-.94.94L6.387 8l-3.054 3.06.94.94 4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m8.667 4-.94.94L10.78 8l-3.053 3.06.94.94 4-4z"
})));
export { SvgDoubleChevronRight as ReactComponent };
export default __webpack_public_path__ + "d32fb03d46542d397c04dd1175222461.svg";